module.exports = __webpack_public_path__ + "img/dwg.7d5899f6.png";